var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamberger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4058_2458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 28,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 6C2.66663 5.46957 2.86731 4.96086 3.22452 4.58579C3.58173 4.21071 4.06621 4 4.57139 4H27.4285C27.9337 4 28.4182 4.21071 28.7754 4.58579C29.1326 4.96086 29.3333 5.46957 29.3333 6C29.3333 6.53043 29.1326 7.03914 28.7754 7.41421C28.4182 7.78929 27.9337 8 27.4285 8H4.57139C4.06621 8 3.58173 7.78929 3.22452 7.41421C2.86731 7.03914 2.66663 6.53043 2.66663 6ZM2.66663 16C2.66663 15.4696 2.86731 14.9609 3.22452 14.5858C3.58173 14.2107 4.06621 14 4.57139 14H27.4285C27.9337 14 28.4182 14.2107 28.7754 14.5858C29.1326 14.9609 29.3333 15.4696 29.3333 16C29.3333 16.5304 29.1326 17.0391 28.7754 17.4142C28.4182 17.7893 27.9337 18 27.4285 18H4.57139C4.06621 18 3.58173 17.7893 3.22452 17.4142C2.86731 17.0391 2.66663 16.5304 2.66663 16ZM2.66663 26C2.66663 25.4696 2.86731 24.9609 3.22452 24.5858C3.58173 24.2107 4.06621 24 4.57139 24H27.4285C27.9337 24 28.4182 24.2107 28.7754 24.5858C29.1326 24.9609 29.3333 25.4696 29.3333 26C29.3333 26.5304 29.1326 27.0391 28.7754 27.4142C28.4182 27.7893 27.9337 28 27.4285 28H4.57139C4.06621 28 3.58173 27.7893 3.22452 27.4142C2.86731 27.0391 2.66663 26.5304 2.66663 26Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4058_2458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#1F2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamberger);
export default __webpack_public_path__ + "static/media/hamberger.339739fb5316ab8b2fa9b722ecd119dc.svg";
export { ForwardRef as ReactComponent };